import React from 'react';
import { Player } from '../core/types';
import { Rules } from '../core/Rules';
import MeldDisplay from './MeldDisplay';
import '../styles/PlayerInfo.css';

interface PlayerInfoProps {
  player: Player;
  isActiveTurn?: boolean;
  speechBubble?: string | null;
  isCompact?: boolean;
}

const PlayerInfo: React.FC<PlayerInfoProps> = ({
  player,
  isActiveTurn = false,
  speechBubble,
  isCompact = false
}) => {
  const huxiBreakdown = () => {
    const exposedHuxi = player.melds.reduce((total, meld) => total + meld.huxi, 0);
    const concealedHuxi = new Map<string, number>();
    player.hand.forEach(card => {
      const key = `${card.type}_${card.value}`;
      concealedHuxi.set(key, (concealedHuxi.get(key) || 0) + 1);
    });
    const handHuxi = Array.from(concealedHuxi.entries()).reduce((total, [key, count]) => {
      if (count >= 4) return total + Rules.getMeldHuxi('TI', key.startsWith('big'));
      if (count === 3) return total + Rules.getMeldHuxi('KAN', key.startsWith('big'));
      return total;
    }, 0);

    return `亮牌 ${exposedHuxi} 胡 + 手牌暗坎/暗提 ${handHuxi} 胡`;
  };

  const exposedHuxi = player.melds.reduce((total, meld) => total + meld.huxi, 0);

  return (
    <div
      className={`player-seat-card ${player.position} ${isActiveTurn ? 'active-turn' : ''} ${
        isCompact ? 'compact' : ''
      }`}
    >
      {/* 气泡台词 */}
      {speechBubble && (
        <div className="speech-bubble">
          <div className="speech-content">{speechBubble}</div>
        </div>
      )}

      <div className="player-avatar-wrap">
        <div className="avatar-icon">{player.avatar}</div>
        {player.isDealer && <div className="dealer-badge">庄</div>}
      </div>

      <div className="player-meta">
        <div className="player-name-row">
          <span className="player-title">{player.name}</span>
          <span className="player-score">得分: {player.score}</span>
        </div>

        <div className="player-stats-row">
          <span className="stat-item hand-count">🎴 剩牌: {player.hand.length}</span>
          <span className="stat-item live-huxi" title={huxiBreakdown()}>桌面胡息: {exposedHuxi}胡</span>
        </div>
      </div>

      {/* 对手亮牌区 */}
      {player.melds.length > 0 && (
        <div className="player-exposed-melds">
          <MeldDisplay melds={player.melds} isCompact={true} />
        </div>
      )}
    </div>
  );
};

export default PlayerInfo;

